export const cleanupStep6 = (data) => {
  const cleanedData = { ...data };
  

  
  return cleanedData;
};